import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { LoanEligibleReq, LoanEligibleRes } from './types';

const checkLoanEligibility = (
  payload: LoanEligibleReq
): Promise<LoanEligibleRes> => {
  return axios<
    LoanEligibleRes,
    BaseResponse<LoanEligibleRes, LoanEligibleReq>,
    LoanEligibleReq
  >({
    url: '/logistical-check',
    method: 'post',
    data: {
      ...payload,
    },
  }).then((res) => res.data.data);
};

export const useCheckLoanEligibility = () => {
  const { mutateAsync, error, isLoading } = useMutation(checkLoanEligibility, {
    useErrorBoundary: false,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { isLoanEligible: mutateAsync, isLoading };
};
